import { Col, Row } from 'reactstrap';

import {
  NonStructuredSectionSchedulesLoader,
  useNonStructuredSectionSchedulesLoader,
} from '../../../../SectionsEdit/hooks/NonStructuredSectionSchedulesLoader';
import SectionScheduleForm from './SectionSchedule/SectionScheduleForm';
import { AcademicOfferScheduleSection } from '../../../types';
import { AcademicOfferScheduleEmpty } from './AcademicOfferScheduleEmpty';

interface SectionScheduleTableWrapperProps {
  onScheduleSaved: () => void;
  isReadOnly?: boolean;
}

function SectionScheduleTableWrapper({
  onScheduleSaved,
  isReadOnly,
}: SectionScheduleTableWrapperProps) {
  const { result } = useNonStructuredSectionSchedulesLoader();
  const data = result?.success ? result.data : null;

  const handleSave = () => {
    onScheduleSaved();
  };

  if (!data) {
    return <AcademicOfferScheduleEmpty />;
  }

  return (
    <SectionScheduleForm
      data={data}
      onSave={handleSave}
      isReadOnly={isReadOnly}
    />
  );
}

interface AcademicOfferSectionScheduleTablesProps {
  sections: AcademicOfferScheduleSection[];
  onScheduleSaved: () => void;
  isReadOnly?: boolean;
}

export function AcademicOfferSectionScheduleTables({
  sections,
  onScheduleSaved,
  isReadOnly,
}: AcademicOfferSectionScheduleTablesProps) {
  return (
    <Row>
      <Col xs={12} className="m-auto">
        {sections.map((section, index) => (
          <div
            key={section.id}
            className={`d-flex flex-column justify-content-center${
              index > 0 ? ' mt-4' : ''
            }`}
          >
            <NonStructuredSectionSchedulesLoader
              defaultQuery={section.id}
              fetchImmediately
            >
              <SectionScheduleTableWrapper
                onScheduleSaved={onScheduleSaved}
                isReadOnly={isReadOnly}
              />
            </NonStructuredSectionSchedulesLoader>
          </div>
        ))}
      </Col>
    </Row>
  );
}
